(function(){
  var KEY = 'vc_wishlist';

  function read() {
    try {
      var arr = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(arr)) return [];
      // dedupe
      var seen = {}, out = [];
      for (var i=0;i<arr.length;i++){ var h = arr[i]; if (h && !seen[h]) { seen[h]=1; out.push(h); } }
      return out;
    } catch(e){ return []; }
  }
  function write(list) { localStorage.setItem(KEY, JSON.stringify(list)); return list; }
  function has(handle){ return read().indexOf(handle) > -1; }
  function add(handle){ var l = read(); if(!has(handle)) l.push(handle); return write(l); }
  function remove(handle){ return write(read().filter(function(h){ return h !== handle; })); }
  function toggle(handle){ return has(handle) ? remove(handle) : add(handle); }

  // Update all heart buttons on the page
  function paintButtons(){
    var nodes = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i=0;i<nodes.length;i++){
      var btn = nodes[i];
      var handle = btn.getAttribute('data-product-handle');
      var active = has(handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.title = active ? 'Remove from wishlist' : 'Add to wishlist';
      btn.innerHTML = active ? '<span aria-hidden="true">♥</span>' : '<span aria-hidden="true">♡</span>';
    }
  }

  // Delegated click handler
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if(!btn) return;
    var handle = btn.getAttribute('data-product-handle');
    toggle(handle);
    paintButtons();
    // Broadcast a simple event other scripts can listen to (e.g. the wishlist page)
    document.dispatchEvent(new CustomEvent('vc:wishlist:updated'));
  });

  // Expose a tiny API if needed
  window.VC_Wishlist = { read: read, write: write, has: has, add: add, remove: remove, toggle: toggle, paintButtons: paintButtons };

  // Paint on load and after theme sections re-render
  document.addEventListener('DOMContentLoaded', paintButtons);
  document.addEventListener('shopify:section:load', paintButtons);
})();
